let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6lTcG")).then(() => parcelRequire('6qUMI'));